import { render, staticRenderFns } from "./customDatasheet.vue?vue&type=template&id=17ec230f&scoped=true&"
import script from "./customDatasheet.vue?vue&type=script&lang=js&"
export * from "./customDatasheet.vue?vue&type=script&lang=js&"
import style0 from "./customDatasheet.vue?vue&type=style&index=0&id=17ec230f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ec230f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
